module.exports = __webpack_public_path__ + "img/checkmark-24px-thin-white.06be98a4.svg";